import FillButton from '@components/Buttons/Fill';
import styled from '@emotion/styled';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 100%;
  width: 100%;
`;

export const Check = styled.img`
  display: block;
  margin: 0 auto;
  width: 50px;
  height: 50px;
`;

export const Title = styled.h2`
  font-size: 24px;
  line-height: 32px;
  margin-top: 20px;
  color: #ffffff;
  white-space: pre;
  text-align: center;
`;

export const Text = styled.div`
  font-size: 16px;
  line-height: 24px;
  margin-top: 10px;
  color: #eeeeee;
  white-space: pre;
  text-align: center;
`;

export const VideoContainer = styled.div`
  height: 300px;
  margin-top: 30px;
  background-color: transparent;
`;

export const EnterRoom = styled(FillButton)`
  width: 173px;
  height: 54px;
  font-size: 18px;
  border-radius: 6px;
  background: #4bb5ce;
  color: #ffffff;
  display: flex;
  justify-content: center;
  margin-top: 30px;
`;

export const ContentDimmedWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
